import {FontWeight} from '../../../lib/cms/src/@types/FontWeight'

export const fontWeights: FontWeight[] = [300, 400, 500, 700, 800]
